import { ToothSvgComponentProps } from '@/modules/patientList/patientStrip/patientStripOdontogram/types';

const SvgImplant = (props: ToothSvgComponentProps) => (
  <svg
    width={17 * (props.wx ?? 1)}
    height={33 * (props.hx ?? 1)}
    viewBox="0 0 17 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={props.className}
  >
    <g id="30 implant">
      <path
        id="post"
        d="M10.6612 31.2567C10.5958 31.4313 10.4289 31.5471 10.2424 31.5471L6.81983 31.5471C6.63362 31.5471 6.46691 31.4317 6.40138 31.2574L5.95201 30.0621L5.95201 19.2885L11.1078 19.2885L11.1078 30.0626L10.6612 31.2567Z"
        fill={props.fill || '#E4E4E7'}
        stroke={props.findingsFill || '#FF5140'}
      />
      <path
        id="abutment"
        d="M13.1137 18.5352C12.9945 18.9694 12.5997 19.2704 12.1494 19.2704L4.91349 19.2704C4.46346 19.2704 4.06887 18.9697 3.94938 18.5359L2.84764 14.5351L14.2122 14.5351L13.1137 18.5352Z"
        fill={props.fill || '#E4E4E7'}
        stroke={props.findingsFill || '#FF5140'}
      />
      <path
        id="thread 3"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.12173 23.8436C4.01012 23.4675 4.22451 23.0722 4.60058 22.9606L12.0551 20.7483C12.4311 20.6367 12.8265 20.8511 12.9381 21.2271C13.0497 21.6032 12.8353 21.9985 12.4592 22.1101L5.00474 24.3224C4.62867 24.434 4.23334 24.2197 4.12173 23.8436Z"
        fill={props.findingsFill || '#FF5140'}
      />
      <path
        id="thread 2"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.12173 26.6443C4.01012 26.2683 4.22451 25.8729 4.60058 25.7613L12.0551 23.549C12.4311 23.4374 12.8265 23.6518 12.9381 24.0279C13.0497 24.4039 12.8353 24.7993 12.4592 24.9109L5.00474 27.1232C4.62867 27.2348 4.23334 27.0204 4.12173 26.6443Z"
        fill={props.findingsFill || '#FF5140'}
      />
      <path
        id="thread 1"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.12173 29.6085C4.01012 29.2324 4.22451 28.8371 4.60058 28.7255L12.0551 26.5132C12.4311 26.4016 12.8265 26.6159 12.9381 26.992C13.0497 27.3681 12.8353 27.7634 12.4592 27.875L5.00474 30.0873C4.62867 30.1989 4.23334 29.9845 4.12173 29.6085Z"
        fill={props.findingsFill || '#FF5140'}
      />
      <path
        id="crown"
        d="M15.1896 1.93977C13.2292 -0.199134 9.83567 1.75982 8.53048 1.75982C7.22529 1.75982 3.83179 -0.199136 1.87139 1.93976C0.300407 3.65355 0.88049 7.77568 2.00643 10.5501C2.42532 11.5822 2.60357 13.4231 2.53938 14.5351L14.6951 14.5351C14.4759 12.411 14.881 11.1385 15.3436 9.77272C16.2642 7.05352 16.6193 3.49979 15.1896 1.93977Z"
        fill={props.findingsFill || '#FF5140'}
        stroke={props.findingsFill || '#FF5140'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);
export default SvgImplant;
